<template>
  <div>
    <b-form-group
      label="Durum"
      label-for="status"
    >
      <b-form-checkbox
        id="status"
        v-model="itemData.is_active"
        value="1"
        switch
      >
        {{ itemData.is_active === 1 ? 'Aktif' : 'Pasif' }}
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'BlogCategoryActiveCard',
  components: { BFormGroup, BFormCheckbox },
  computed: {
    itemData() {
      return this.$store.getters['blogCategories/dataItem']
    },
  },
}
</script>
